import Vue from 'vue';
import VueRouter from "vue-router";
import { publicPath, routerMode } from "@/config/settings";
Vue.use(VueRouter);
import Layout from '@/layout'

export const constantRoutes = [
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/login'),
    meta: { title: '登录' }
  },
  {
    name: 'Register',
    path: '/register',
    component: () => import('@/views/register'),
    meta: { title: '注册' }
  },
  {
    name: '401',
    path: '/401',
    component: () => import('@/views/error/401'),
    meta: { title: '无权限访问' }
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/error/404'),
    meta: { title: '未找到该页面' }
  }
];

export const asyncRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/404',
    children: [
      {
        name: 'Service',
        path: '/service',
        component: () => import('@/views/service'),
        meta: { title: '业务', permissions: [421, 422, 423, 424, 426, 428, 425, 427, 441, 431, 401, 402, 403, 404, 111, 112, 141, 142, 143, 144, 145, 146, 151, 152, 153, 154, 161, 162, 163, 164, 221] }
      },
    ]
  },
  {
    path: '/service',
    component: Layout,
    children: [
      {
        name: 'VehicleApply',
        path: '/service/business/vehicle',
        component: () => import('@/views/service/business/vehicle/index'),
        meta: { title: '加油申请', permissions: [421, 422, 423, 424, 426] }
      },
      {
        name: 'VehicleCheckApply',
        path: '/service/business/vehicle-apply',
        component: () => import('@/views/service/business/vehicleApply/index'),
        meta: { title: '审核加油申请', permissions: [428, 425, 427] }
      },
      {
        name: 'ServiceHistoryRefuel',
        path: '/service/history/refuel',
        component: () => import('@/views/service/history/refuel/index'),
        meta: { title: '加油记录', permissions: [441] }
      },
      {
        name: 'ServiceHistoryRefuelReport',
        path: '/service/history/refuel-report',
        component: () => import('@/views/service/history/refuel-report/index'),
        meta: { title: '加油报表', permissions: [431] }
      },
      {
        name: 'ServiceHistoryOilInStock',
        path: '/service/history/oil-in-stock',
        component: () => import('@/views/service/history/oil-in-stock/index'),
        meta: { title: '燃油入库记录', permissions: [481] }
      },
      {
        name: 'ServiceSystemVehicle',
        path: '/service/system/vehicle',
        component: () => import('@/views/service/system/vehicle/index'),
        meta: { title: '车辆管理', permissions: [401, 402, 403, 404] }
      },
      {
        name: 'ServiceSystemVehicleCreate',
        path: '/service/system/vehicle/create',
        component: () => import('@/views/service/system/vehicle/create'),
        meta: { title: '添加车辆', permissions: [402] }
      },
      {
        name: 'ServiceSystemVehicleUpdate',
        path: '/service/system/vehicle/update',
        component: () => import('@/views/service/system/vehicle/update'),
        meta: { title: '更新车辆', permissions: [403] }
      },
      {
        name: 'ServiceProjectMessage',
        path: '/service/project/message',
        component: () => import('@/views/service/project/message/index'),
        meta: { title: '消息推送', permissions: [111, 112] }
      },
      {
        name: 'ServiceProjectMessageUpdate',
        path: '/service/project/message/update',
        component: () => import('@/views/service/project/message/update'),
        meta: { title: '更新推送人群', permissions: [112] }
      },
      {
        name: 'ServiceProjectPort',
        path: '/service/project/port',
        component: () => import('@/views/service/project/port/index'),
        meta: { title: '物料盘点', permissions: [131, 132, 133] }
      },
      {
        name: 'ServiceSystemStaff',
        path: '/service/system/staff',
        component: () => import('@/views/service/system/staff/index'),
        meta: { title: '用户列表', permissions: [141, 142, 143, 144, 145, 146] }
      },
      {
        name: 'ServiceSystemStaffCreate',
        path: '/service/system/staff/create',
        component: () => import('@/views/service/system/staff/create'),
        meta: { title: '添加用户', permissions: [142] }
      },
      {
        name: 'ServiceSystemStaffUpdate',
        path: '/service/system/staff/update',
        component: () => import('@/views/service/system/staff/update'),
        meta: { title: '更新用户', permissions: [143] }
      },
      {
        name: 'ServiceSystemDepartment',
        path: '/service/system/department',
        component: () => import('@/views/service/system/department/index'),
        meta: { title: '部门列表', permissions: [151, 152, 153, 154] }
      },
      {
        name: 'ServiceSystemDepartmentCreate',
        path: '/service/system/department/create',
        component: () => import('@/views/service/system/department/create'),
        meta: { title: '添加部门', permissions: [152] }
      },
      {
        name: 'ServiceSystemDepartmentUpdate',
        path: '/service/system/department/udpate',
        component: () => import('@/views/service/system/department/update'),
        meta: { title: '更新部门', permissions: [153] }
      },
      {
        name: 'ServiceSystemRole',
        path: '/service/system/role',
        component: () => import('@/views/service/system/role/index'),
        meta: { title: '角色列表', permissions: [161, 162, 163, 164] }
      },
      {
        name: 'ServiceSystemRoleCreate',
        path: '/service/system/role/create',
        component: () => import('@/views/service/system/role/create'),
        meta: { title: '添加角色', permissions: [162] }
      },
      {
        name: 'ServiceSystemRoleUpdate',
        path: '/service/system/role/update',
        component: () => import('@/views/service/system/role/update'),
        meta: { title: '更新角色', permissions: [163] }
      },
      {
        name: 'ServiceUserPassword',
        path: '/service/user/password',
        component: () => import('@/views/service/user/password/index'),
        meta: { title: '修改密码' }
      },
      {
        name: 'applyManual',
        path: '/service/manual/apply',
        component: () => import('@/views/service/manual/apply/index'),
        meta: { title: '加油申请使用说明书' }
      },
      {
        name: 'managerManual',
        path: '/service/manual/manager',
        component: () => import('@/views/service/manual/manager/index'),
        meta: { title: '加油管理系统电脑端说明书' }
      },
      {
        name: 'systemManual',
        path: '/service/manual/system',
        component: () => import('@/views/service/manual/system/index'),
        meta: { title: '加油管理系统移动端说明书' }
      },
      {
        name: 'ServiceUserLog',
        path: '/service/user/log',
        component: () => import('@/views/service/user/log/index'),
        meta: { title: '运行日志', permissions: [221] }
      },
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  }
];

const router = new VueRouter({
  base: publicPath,
  mode: routerMode,
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRoutes,
});

export function resetRouter() {
  router.matcher = new VueRouter({
    base: publicPath,
    mode: routerMode,
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  }).matcher;
}

export default router;
